import { render, staticRenderFns } from "./coupon-reward-dialog.vue?vue&type=template&id=cfc7630c&scoped=true&"
import script from "./coupon-reward-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./coupon-reward-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./coupon-reward-dialog.vue?vue&type=style&index=0&id=cfc7630c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc7630c",
  null
  
)

export default component.exports